const a = {indicator: '[data-slider-progress-indicator]'};
class p {
  constructor({element: e, slider: t}) {
    (this.slider = t),
      (this.elements = {wrapper: e, indicator: e.querySelector(a.indicator)}),
      (this.onSliderChange = () => this.updateIndicator()),
      (this.onSliderResize = () => this.updateIndicator()),
      (this.onWrapperClick = this.handleClick.bind(this)),
      this.slider.on('change', this.onSliderChange),
      this.slider.on('resize', this.onSliderResize),
      this.updateIndicator(),
      this.elements.wrapper.addEventListener('click', this.onWrapperClick);
  }
  updateIndicator() {
    var r, n, o;
    const e = ((n = (r = this.slider) == null ? void 0 : r.slides) == null ? void 0 : n.length) || 0,
      t = Math.min(Math.max(((o = this.slider) == null ? void 0 : o.selectedIndex) || 0, 0), Math.max(e - 1, 0)),
      i = e ? (t / e) * 100 : 0,
      s = e > 1 ? t / (e - 1) : 0;
    this.elements.wrapper.style.setProperty('--slide-count', e),
      this.elements.wrapper.style.setProperty('--indicator-offset', `${i}%`),
      this.elements.wrapper.style.setProperty('--progress-ratio', s);
  }
  handleClick(e) {
    var d, c;
    e.preventDefault();
    const t = this.elements.wrapper.getBoundingClientRect(),
      i = t.width,
      s = ((c = (d = this.slider) == null ? void 0 : d.slides) == null ? void 0 : c.length) || 0;
    if (!s || !Number.isFinite(i) || i <= 0) return;
    const n = ((e.clientX - t.left) / i) * 100,
      o = Math.floor((n / 100) * s),
      l = Math.min(Math.max(o, 0), s - 1);
    l !== this.slider.selectedIndex && this.slider.select(l);
  }
  destroy() {
    var e, t, i, s, r;
    (t = (e = this.slider) == null ? void 0 : e.off) == null || t.call(e, 'change', this.onSliderChange),
      (s = (i = this.slider) == null ? void 0 : i.off) == null || s.call(i, 'resize', this.onSliderResize),
      (r = this.elements.wrapper) == null || r.removeEventListener('click', this.onWrapperClick),
      (this.slider = null);
  }
}
export {p as S};
